import { Plugin } from "@ckeditor/ckeditor5-core";

export default class MediaInsertEditing extends Plugin {
  init() {
    const editor = this.editor;
    this._defineConverters();
    this._defineSchema();
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    conversion.for("downcast").elementToElement({
      model: { name: "audio", attributes: ["src", "controls"] },
      view: (modelElement, { writer }) => {
        return writer.createContainerElement("audio", {
          src: modelElement.getAttribute("src"),
          controls: modelElement.getAttribute("controls"),
        });
      },
    });

    conversion.for("downcast").elementToElement({
      model: { name: "video", attributes: ["src", "controls"] },
      view: (modelElement, { writer }) => {
        return writer.createContainerElement("video", {
          src: modelElement.getAttribute("src"),
          controls: modelElement.getAttribute("controls"),
        });
      },
    });

    conversion.for("upcast").elementToElement({
      view: { name: "audio", attributes: ["src", "controls"] },
      model: (viewElement, { writer }) => {
        return writer.createElement("audio", {
          src: viewElement.getAttribute("src"),
          controls: viewElement.getAttribute("controls"),
        });
      },
    });

    conversion.for("upcast").elementToElement({
      view: { name: "video", attributes: ["src", "controls"] },
      model: (viewElement, { writer }) => {
        return writer.createElement("video", {
          src: viewElement.getAttribute("src"),
          controls: viewElement.getAttribute("controls"),
        });
      },
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.register("audio", {
      allowWhere: "$block",
      allowIn: "$root",
      isObject: true,
      isBlock: true,
      allowAttributes: ["src", "controls"],
    });

    schema.register("video", {
      allowWhere: "$block",
      allowIn: "$root",
      isObject: true,
      isBlock: true,
      allowAttributes: ["src", "controls"],
    });
  }
}
